var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"logo-ul"}},_vm._l((_vm.logos),function(logo){return _c('li',{key:logo.href,staticClass:"logo-li"},[_c('a',{staticClass:"logo-a",attrs:{"href":logo.href,"target":"_blank"}},[_c('img',{staticClass:"logo-img",attrs:{"src":logo.src,"alt":"logo"}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }